import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { appLanguageKey } from '../../constants/appConstants';

const disneyInstance = i18n.createInstance();

disneyInstance.use(initReactI18next).init({
    lng: localStorage.getItem(appLanguageKey) || 'en',
    fallbackLng: 'en',
    debug: true,
    react: { useSuspense: true },
    missingInterpolationHandler: () => '',
    resources: {
        en: {
            translation: {
                appFooter:
                    'If you need assistance or have questions about the Airport Luggage Transfer at Disney service, please contact BagCheck Customer Service at <0>BCsupport@bagcheck.com</0> or call <1>(407) 505-7443</1> between 7:00 AM and 11:30 PM Eastern Time.',
                enrollmentLandingPageDescription:
                    'Guests staying at select Disney Resorts Collection hotels can use this new pilot program provided by BagCheck to transfer their luggage to and from Orlando International Airport—only when flying with a <0>participating airline</0>.',
                enrollmentLandingPageTitle:
                    'Register for Airport Luggage Transfer at Disney provided by BagCheck',
                howItWorks: 'How it works:',
                youthGroupDescription:
                    'For Youth Groups, please <0>click here</0> to register.',
                enrollYourReservation: 'Step 1: Verify Your Reservation',
                enrollYourReservationDescription:
                    'Guests staying at select <0>Disney Resorts Collection hotels</0> are eligible for this service. Submit your information to verify your eligibility.',
                enrollYourReservationNote:
                    'Enrollment is only required for your arrival into Orlando.',
                alreadyEnrolled: 'Already enrolled?',
                alreadyEnrolledDescription:
                    'Enter your reservation details to view or modify your enrollment.',
                enrollmentCriteriaSubheader1:
                    'Arriving to Orlando International Airport (MCO)',
                enrollmentCriteriaSubheader2:
                    'Departing <i>Walt Disney World</i> Resort®',
                enrollmentCriteria1:
                    'Complete registration anytime between 30 days and 24 hours prior to your Disney Resort check in',
                enrollmentCriteria2:
                    'Check in to your flight and pay any required baggage fees.',
                enrollmentCriteria3:
                    'If you register for this service less than 7 days before your Resort check in date, you will not receive luggage tags—we will still collect your bags at the airport and transfer them to your Disney Resorts Collection hotel, and you will be able to track the status of your luggage.',
                enrollmentCriteria4:
                    "Place your luggage tag on your checked luggage, head to the airport and follow your airline's procedure to drop off your luggage.",
                enrollmentCriteria5:
                    "After landing at Orlando International Airport, there's no need to stop at baggage claim—your checked luggage will be delivered directly to your Disney Resorts Collection hotel within four hours.",
                enrollmentCriteria6:
                    'You only need to enroll for your arrival into Orlando in order to have your luggage delivered directly to your Disney Resort hotel. No additional enrollment is required for your return trip home.',
                enrollmentCriteria7:
                    'Drop off your bags at Luggage Assistance anytime between 24 and 4 hours prior to your flight departure time.',
                enrollmentCriteria8:
                    'Please have your boarding pass and valid government-issued photo ID ready and ensure any applicable airline baggage fees have been paid prior to arrival.',
                reservationNumber: 'Resort Confirmation Number',
                reservationNumberRequired: 'Resort Confirmation Number *',
                primaryGuestLastName: 'Last Name',
                arrivalDate: 'Resort Arrival Date',
                arrivalDateRequired: 'Resort Arrival Date *',
                next: 'Next',
                reservationNumberInvalid:
                    'Please enter a valid alphanumeric reservation number at least 6 characters long.',
                lastNameInvalid:
                    'Please enter a valid last name with no numbers or special characters.',
                arrivalDateInvalid:
                    'Your selected check-in date is outside the enrollment window. Registration is available from 30 days up to 1 day prior to your Resort check-in.',
                serviceUnavailableHeading: 'Service Unavailable.',
                reservationNumberInvalidHeading: 'Reservation Not Found',
                serviceUnavailableGuidance: 'The service is temporarily unavailable. Please try again later.',
                enrollmentRequestInvitation:
                    "We couldn't find a reservation matching the information provided. Please verify your reservation details and eligibility, then try again. If you're still unable to locate your reservation, you may <0>submit your information manually here</0> and our team will review your request for enrollment.",
                resortNameRequired: 'Resort Name *',
                infoPanelAssistance1:
                    'If you need assistance, please contact BagCheck Customer Service at',
                infoPanelAssistance2:
                    'between 7:00 AM and 11:30 PM Eastern Time',
                // Flight Details Page
                flightInformationTitle: 'Flight Information',
                flightInformationInstructions:
                    "To help us take care of everything for you, please enter your airline flight information for all ticketed Guests in your party who would like to participate and have their luggage delivered directly to your Disney Resort. If you don't have everyone's flight details right now, you can still enroll and come back later to add or update the information at your convenience.",
                applyFlightInfoToAllTravelers:
                    'Apply Flight Information to All Travelers',
                submitEnrollment: 'Submit Enrollment',
                airlineLabel: 'Airline *',
                selectAirline: 'Select Airline',
                flightNumberLabel: 'Flight Number',
                flightNumberPlaceholder: 'e.g., 1234',
                pnrLabel: 'Flight Confirmation Number *',
                pnrPlaceholder: 'e.g., ABC123',
                primaryGuest: 'Primary Guest',
                emailConfirmation: 'Email Confirmation',
                emailConfirmationDescription:
                    "We'll send you a confirmation email with your enrollment details and shareable link. This email will only be used for enrollment confirmation and will not be shared with third parties.",
                emailAddressLabel: 'Email Address *',
                emailAddressPlaceholder: 'your.email@example.com',
                loadingReservation: 'Loading reservation details...',
                flightArrivalDateLabel: 'Flight Arrival Date *',
                flightArrivalDatePlaceholder: 'MM/DD/YYYY',
                fullNameRequired: 'Full Name *',
                recipientName: 'Recipient Name',
                line: 'Line',
                numberOfTags: 'How many tags should be sent to this address',
                address: 'Address',
                addressRequired: 'Address *',
                eligible: 'Eligible',
                ineligible: 'Ineligible',
                flightEntryErrors: {
                    airlineNotEligible:
                        'Invalid Airline: Remember that this service is only eligible for travelers flying on Southwest Airlines.',
                    flightNotFound:
                        'Flight Not Found: Please verify the flight number and airline for this traveler and try again.',
                    flightResortArrivalMismatch:
                        'Flight Arrival Date Mismatch: Your flight arrival date does not match your resort arrival date.',
                    flightOutsideOfOperationalWindow:
                        'Invalid Flight Time: This service is only offered for Southwest Airlines flights that arrive at Orlando International Airport between 7:00AM and 11:00PM.',
                },
                // Address Page
                // address: 'Address',
                addressPageTitle: 'Luggage Tag Shipping Details',
                addressPageDescription:
                    'Please provide your preferred shipping address and quantity of luggage tags requested below. Be sure to arrive at the airport with your luggage tags secured to your checked bags. You do not need to apply tags to your carry-on items. Additional luggage tags will not be available at the airport.',
                addAnotherAddress: 'Add Another Address',
                contactInformationTitle: 'Contact Information',
                contactInformationDescription:
                    'Please provide an email where we can send your enrollment confirmation and a phone number for any delivery questions.',
                // Confirmation Page
                confirmationPageTitle: 'Registration Confirmed!',
                confirmationPageUpdatedTitle: 'Updated Registration Confirmed!',
                enrollmentDetailsSubtitle: 'Enrollment Details',
                disneyResortHotel: 'Disney Resorts Collection Hotel',
                manageEnrollmentSubtitle: 'Manage Enrollment',
                guestDetailsSubtitle: 'Guest Details',
                luggageTagDetailsSubtitle: 'Luggage Tag Details',
                modifyYourFlight: 'Modify your flight',
                modifyYourFlightDescription:
                    'information up to the day of travel',
                nextStepsSubtitle: 'Next Steps',
                nextStepsDescription1:
                    'You will receive a confirmation email shortly with details about your enrollment. Keep an eye on your mailbox! Luggage Tags will be mailed to the address(es) provided within 48 hours after enrollment. If you have not received your luggage tags by 72 hours before your flight, please contact BagCheck at <0>bcsupport@bagcheck.com</0> or by phone at <1>(407) 505-7443</1> between 7:00 AM and 11:30 PM Eastern Time.',
                nextStepsDescription2:
                    'If you need additional luggage tags or have any other questions, please contact BagCheck at <0>bcsupport@bagcheck.com</0> or by phone at <1>(407) 505-7443</1> between 7:00 AM and 11:30 PM Eastern Time.',
                nextStepsUpdatedDescription1:
                    'You will receive an email shortly confirming the changes to your enrollment.',
                cancelEnrollment:
                    'If you would like to cancel your enrollment,',
                guestEmail: 'Guest Email',
                guestPhoneNumber: 'Guest Phone Number',
                phoneNumberDisclaimer:
                    'By providing your phone number and submitting this form, you are consenting to be contacted by SMS text message. Message & data rates may apply. You can reply STOP to opt-out of further messaging.',
                // Modify Flight Details Page
                // Modify Contact Details Page
                modifyContactDetailsTitle: 'Modify Contact Details',
                modifyContactDetailsDescription:
                    'You may modify your contact information below. If you would like to make changes to your shipping address or request additional luggage tags, please contact <0>BagCheck Support</0>.',
                submitChanges: 'Submit Changes',

                // Enrollment Request Page
                numberOfBagsRequired: 'Number of Bags *',
                numberOfPassengersOptional: 'Number of Passengers',
                emailAddressRequired: 'Email Address *',
                emailAddressInvalid: 'Please enter a valid email address.',
                phoneNumberRequired: 'Phone Number *',
                phoneNumberInvalid: 'Please enter a valid phone number.',
                fullNameInvalid:
                    'Please enter a valid full name with no numbers or special characters.',
                airlineInvalid: 'Please fill out an airline.',
                resortInvalid: 'Please fill out a resort.',
                pnrInvalid: 'Please enter a 6 character alphanumeric PNR.',
                numberOfBagsInvalid: 'Please enter a valid number of bags.',
                mailingAddressInvalid: 'Please enter a valid mailing address.',

                // Bag Tracking Page
                bagTrackingPageTitle: 'Airport Luggage Transfer at Disney',
                bagTrackingPageSubtitle: 'Luggage Tracking Details',
                bagTrackingPageDescription:
                    'Track your luggage from your departure airport to your Disney Resort hotel.',
                bagTrackingPageNoEventsDescription:
                    'Your bag tracking information has not been created yet. Please check back once you arrive at your destination airport or contact <0>BagCheck Support</0> for assistance.',
                bagTagNumber: 'Luggage Tag Number',
                LuggageCheckedAtEvent:
                    'Luggage was checked and tagged at {{location}}',
                LuggageReceivedByBagCheck:
                    'Luggage received by BagCheck at Orlando International Airport',
                LuggageInTransit:
                    'Luggage on its way to your Disney Resorts Collection Hotel',
                LuggageAtResort:
                    'Luggage has arrived at your Disney Resorts Collection Hotel. Please pick it up from Luggage Assistance/Bell Services in your hotel lobby area, or use your in-room phone to have it delivered directly to your room.',
                LuggageCheckedAtEventHelperText:
                    'Your luggage has been checked in for your flight. If you have any questions about your luggage at this time, please contact your airline.',
                LuggageReceivedByBagCheckHelperText:
                    'Your luggage has been received by BagCheck in Orlando and is being sorted for delivery. If you have any questions about your luggage at this time, please contact <0>BagCheck Support</0>.',
                LuggageInTransitHelperText:
                    'Your luggage has been loaded for delivery and is on its way to you. If you have any questions about your luggage at this time, please contact <0>BagCheck Support</0>.',
                LuggageAtResortHelperText:
                    'Luggage has arrived at your Disney Resorts Collection Hotel. Please pick it up from Luggage Assistance/Bell Services in your hotel lobby area, or use your in-room phone to have it delivered directly to your room. Remember, this complimentary service is available on your way home, too! Visit <0>DisneyWorld.com/luggage</0> for more information.',
                backToEnrollment: 'Back to Enrollment',
                // Cancel Enrollment Page
                cancelEnrollmentTitle: 'Cancel Enrollment',
                enrollmentCanceledTitle: 'Enrollment Canceled',
                cancelEnrollmentDescription:
                    'Are you sure you want to cancel your enrollment in the Airport Luggage Transfer at Disney service? If you cancel your enrollment, you will need to pick up your bags at baggage claim when you arrive at the Orlando International Airport. BagCheck will not transfer your bags to your resort.',
                reactivateEnrollmentDescription:
                    'If you would like to reactivate your enrollment, please contact <0>BagCheck Support</0>',
                // addressExpiry: 'Address expires on',
                // addressExpiryPastTense: 'Address expired on',
                // additionalDetails: 'Additional details',
                // addPermanentAddress: 'Add permanent address (optional)',
                // and: 'and',
                // appleAirTag: 'Share Apple AirTag location (optional)',
                // appleAirTagErrorMessage:
                //     'Provided AirTag url is invalid, please ensure url begins with "find.apple.com"',
                // appleAirTagHowTo: 'How to share AirTag location',
                // appleAirTagHowToLink:
                //     'https://support.apple.com/guide/iphone/iph3bedf2cc5/ios',
                // appleAirTagUrl: 'Apple AirTag url',
                // appleAirTagPlaceholder: 'Enter your Apple AirTag location URL',
                // artPortfolio: 'Art portfolio case',
                // audioVideoEquipment: 'Audio/Video/Visual/Photo equipment',
                // babyCarriage: 'Full-size baby carriage',
                // bags: 'bags',
                back: 'Back',
                // backpack: 'Backpack/Rucksack',
                // baggageTrolley: 'Baggage trolley',
                // beddingBag: 'Bedding bag',
                // beige: 'Beige',
                // bicycle: 'Bicycle and/or accessories',
                // black: 'Black',
                // blue: 'Blue',
                // bookingReference: 'Booking Reference',
                // box: 'Box',
                // boxes: 'Boxes/Cases',
                // brand: 'Brand',
                // brandPlaceholder: 'Brand Placeholder',
                // briefcase: 'Briefcase',
                // brown: 'Brown',
                // cancel: 'Cancel',
                // carSeat: "Child's car/booster seat",
                // cellNumber: 'Secondary phone',
                // child: "Infant/Child's item",
                city: 'City',
                // claimNumber: 'Delayed Bag File Number',
                // claimNumberPlaceholder: 'Example: YYZAC12345',
                // close: 'Close',
                // clear: 'Clear',
                // colour: 'Colour',
                // computerEquipment: 'Computer/Communications equipment',
                confirm: 'Confirm',
                // contactInformation: 'Contact Information',
                // continue: 'Continue',
                // contactInformation1:
                //     'For updates about your claim, please visit:',
                // contactInformation2: 'Call toll-free at:',
                // contactLink: 'https://www.aircanada.com/delayedbaggage',
                // contactLinkUrl: 'https://www.aircanada.com/delayedbaggage',
                // contactPhoneNumber: '1-888-689-BAGS (2247)',
                // cooler: 'Ice chest/Cooler',
                // cosmeticCase: 'Cosmetic/Beauty case',
                country: 'Country',
                // courierBag: 'Courier bag',
                // customsDateOfBirth: 'Date of birth - YYYY/MM/DD',
                // customsDeclarationSignoff: 'CUSTOMS DECLARATION SIGNOFF',
                // customsDepartureCountry:
                //     'Where are you arriving from? (Country)',
                // customsIsCanada: 'Are you a resident of Canada?',
                // customsNonResident: 'Non-resident of Canada',
                // customsResident: 'Resident of Canada',
                // customsStayOrLeaveDuration:
                //     'How many days have you been absent from Canada or how many days will you be staying in Canada?',
                // customsWarning:
                //     'WARNING: Baggage is examined by Customs and there are heavy penalties for making false declarations',
                // deliveryAddress: 'Current Shipping Address',
                // deliveryAddressTitle: 'Current Delivery Address',
                // additionalAddressTitle: 'Additional {{type}} Address',
                // temporaryType: 'Temporary',
                // permanentType: 'Permanent',
                // deliveryPermanentAddress: 'Deliver to Permanent Address',
                // discardClaim: 'Discard and leave',
                // discardClaimConfirmation:
                //     'Are you sure you want to leave? Your changes will be lost.',
                // diveBag: 'Dive bag/equipment',
                // documentCase: 'Document case',
                // duffel: 'Duffel/Sport bag',
                // dutyFreeItems: 'Duty-free items',
                // editHomeAddressInstruction:
                //     'Your current delivery address is temporary. To avoid any unnecessary delays, please provide a permanent home address where we can send your bag should your current delivery address no longer valid. This ensures that we can get your belongings to you as soon as possible.',
                // electricalAppliance: 'Electrical appliance',
                emailAddress: 'Email address',
                // emailMe: 'Email Me',
                // familyName: 'Last Name',
                // fileClaim: 'Arrange Delivery',
                // fileNumber: 'File number',
                // firearm: 'Firearm(s)',
                // fishingRod: 'Fishing rod',
                // foldingChair: 'Folding chair',
                // frequentFlyerNumber: 'Aeroplan number',
                // frequentFlyerPlaceholder: 'Aeroplan Example: AC123456789',
                // frequentFlyerMissingStartingLetters:
                //     'Aeroplan number is invalid, two letter carrier code expected at the beginning.',
                // frequentFlyerNotAlphaNumeric:
                //     'Aeroplan number provided is invalid.',
                // frequentFlyerNotLongEnough:
                //     'At least 9 digits following the carrier code is required.',
                // garmentBag: 'Garment bag/Suit carrier',
                // generalConditions: 'General Conditions of Carriage & Tarrifs',
                // generalConditionsUrl:
                //     'https://can01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fwww.aircanada.com%2Fca%2Fen%2Faco%2Fhome%2Flegal%2Fconditions-carriage-tariffs.html%23%2F&data=05%7C01%7Crjones%40brocksolutions.com%7C44a8d5eb1b5e482fcb6e08db4d620cfc%7Cc915bb9fc8a1443ba63d36382385f940%7C0%7C0%7C638188855742971362%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C3000%7C%7C%7C&sdata=6XjfGrPfi4vYMIrg0JFlbh7wtOH%2BnIBZaJTA%2Fozw%2Bwg%3D&reserved=0',
                // generalBagPolicy: 'Information on missing and delayed bags',
                // generalBagPolicyUrl:
                //     'https://www.aircanada.com/ca/en/aco/home/plan/baggage/delayed-damaged-baggage.html#/',
                // golfBag: 'Golf bag and/or clubs',
                // green: 'Green',
                // grey: 'Grey',
                // hatBox: 'Hat box',
                // horizontalExpandable: 'Horizontal design, expandable',
                // horizontalHardshell: 'Horizontal design, hard shell',
                // horizontalNonExpandable: 'Horizontal design, non expandable',
                // horizontalSuitcase: 'Horizontal design',
                inputInvalid: 'you entered is invalid',
                // instructionInvalidFieldError:
                //     'Please provide the following key fields for delayed baggage file search:',
                // inputTooShort: 'Enter at least {{length}} characters',
                // instructionAddressForm:
                //     'Tell us the delivery address for your bag and your contact information so that we can keep you updated.\n\nYou can make changes by calling us after your file is created.',
                // instructionAddressFormTracerAddress:
                //     'Stay updated by providing your contact information and delivery address.',
                // instructionBagDetails:
                //     'View your item details as it is processed and loaded for the journey',
                // instructionBagInformationForm:
                //     "Please let us know the colour and type of your delayed baggage, to help our reconciliation team visually identify them.\n\nIf you're not sure of the colour and type of each bag, then select the best possible match. You can make changes to your file once it's created.",
                // instructionClaimSubmitted:
                //     'Thank you for the information you submitted regarding your delayed baggage',
                // instructionClaimSummary1:
                //     '\nEdit relevant details to update file',
                // instructionGeneralError:
                //     'At this time, we cannot determine the status of your baggage',
                // instructionUnavailableError:
                //     'At this time, this application is currently unavailable',
                // instructionLandingPageDelayedBagFileSearch:
                //     'To edit the personal information associated with your delayed bag file (e.g. delivery address), please enter your details below.',
                // instructionLandingPage:
                //     'Enter your details below to open a delayed baggage file and arrange delivery of your belongings if they did not arrive on your Air Canada flight.\n\nThis search will only display passengers on this booking with the same last name. If there are other passengers on your booking with a different last name, please submit a new report for each one once you have completed this delayed baggage file.',
                // instructionNoPassengers:
                //     'There are no mishandled bags at this time',
                // instructionPassengerDetails:
                //     'Select your item to view its journey',
                // instructionSearchClaim1:
                //     'Already have a delayed bag file number?',
                // instructionSearchClaim2: '',
                // searchMyClaim: 'Search',
                // searchAgain: 'Search Again',
                // instructionPrivacyStatement:
                //     'Privacy Act Statement\nThe information you provide in this document is collected under the authority of the Customs Act - Section 12 for the purpose of determining the admissibility, duty and tax treatment of the goods you are importing. The information may be disclosed to Air Carrier agents and baggage handling companies for the purposes of presenting your goods for examination by the Canada Border Services (CBSA).\n\nFailure to complete this form may result in punitive action including seizure of your goods. Individuals have the right of access to, the protection and correction of their personal information under the Privacy Act - Section 12. The information collected is described under the Personal Information Bank Delayed Baggage Report CBA PPU 1109 which is detailed at ',
                // instructionPrivacyStatementLink: 'https://www.infosource.gc.ca',
                // instructionSubmitClaim:
                //     "Select which bag or bags you would like to report as delayed. This will open a delayed baggage file with us to follow up on. In the next steps, you will provide information to help identify your bag, as well as provide contact and delivery information so that we can get your belongings back to you as quickly as possible.\n\nThe list below will only display passengers on this booking with the same last name. If there are other passengers on your booking with a different last name, please start again with that passenger's last name.",
                // isTemporary: 'I will be at this address for a limited time',
                // item: 'Item',
                // laptop: 'Laptop/Overnight bag',
                // luggage: 'Luggage/Bags',
                // luggageMiscellaneous: 'Select type',
                // mattedWovenBag: 'Matted woven bag',
                // militaryStyleBag: 'Military style bag',
                // miscellaneous: 'Miscellaneous/Other item',
                // mobility: 'Medical/mobility/wheeled device',
                // multicolour: 'Multicolour',
                // musicalInstrument: 'Musical instrument',
                // next: 'Next',
                name: 'Name',
                // no: 'No',
                // noAvailableService:
                //     "We're sorry, an issue prevents us from providing service. We are working hard to resolve the problem, please try again later.",
                // noBagEventsMessage: 'No declarations found for this bag',
                // noBagInformation1:
                //     "We're sorry, an issue prevents us from retrieving the information on your delayed baggage.",
                // noBagInformation2:
                //     'Please see an Air Canada agent for assistance before leaving the airport.',
                // nonResidentInstruction1:
                //     'Do the missing bags contain any gifts to residents of Canada which exceed CAN$60 in value per item or any other goods which will be left in Canada?',
                // noPassengersMessage:
                //     'Unable to locate delayed baggage file with provided information.',
                noResults: 'No results',
                // notes: 'Notes',
                // notesPlaceholder: 'Notes Placeholder',
                // noZipper: 'My bag closes without a zipper',
                // noZipperBags: 'Bags without a zipper',
                // notificationModalHeader: 'Turn On Notifications',
                // notificationModalInstruction1:
                //     'Enter your email to receive notifications alerts about your bag status',
                // notificationModalInstruction2: 'Receive alerts',
                // notificationModalTitle: 'Get Notified',
                // notifyMe: 'Notify Me',
                optional: 'optional',
                // or: 'Or',
                // orthopaedicDevice: 'Orthopaedic device',
                // other: 'Other',
                // otherChildEquipment: "Other infant/child's item",
                // otherSportEquipment: 'Other sports/outdoor equipment',
                // passengers: 'passengers',
                // passengersExpiredMessage:
                //     "We're sorry, an issue prevents us from retrieving the information on your delayed baggage.\n\nPlease see an Air Canada agent for assistance before leaving the airport.",
                // pattern: 'Pattern',
                // petCarrier: 'Pet carrier',
                // permanentPhone: 'Permanent phone',
                phoneNumber: 'Phone number',
                // phoneNumberPlaceholder: '',
                // plasticLaundryBag: 'Plastic/Laundry bag',
                postalCode: 'ZIP Code',
                // bagWarningModalHeader: 'Alert: Too many {{itemType}} selected',
                // bagWarningModalBody:
                //     'Please reduce the number of {{itemType}} selected to less than {{itemCount}}',
                // poweredBy: 'Powered by',
                // prohibitedItems1: 'Alcohol',
                // prohibitedItems2: 'Tobacco',
                // prohibitedItems3:
                //     'Firearms or other weapons (e.g. switchblades, Mace or pepper spray)',
                // prohibitedItems4:
                //     'Commercial goods, whether or not for resale (e.g. samples, tools, equipment)',
                // prohibitedItems5:
                //     'Meat, fish, seafood, eggs, dairy products, fruits, vegetables, seeds, nuts, plants, flowers, wood, animals, birds, insects, and any parts, products or by-products of any of the foregoing',
                // prohibitedItems6:
                //     'Currency and/or monetary instruments totalling CAN$10,000 or more per person',
                // prohibitedItems7: 'No to all',
                // purple: 'Purple',
                // red: 'Red',
                // save: 'Save',
                // residentInstruction1:
                //     'What is the total value of all the goods you are bringing into Canada which were declared as having been purchased, received or acquired in any manner while outside Canada, including Duty Free shops purchases prior to departure from Canada or abroad?',
                // residentInstruction2:
                //     'To the best of your knowledge, what is the total value of the above goods that are contained in the missing',
                // signatureOfTraveller: 'Signature of traveller',
                // securityRemovedItem: 'Item removed by security',
                // selectColour: 'Select colour',
                // selectPassengers: 'Select Passenger(s)',
                // selectType: 'Select type',
                // shoppingBag: 'Shopping bag (all materials)',
                // signatureCertification:
                //     'I certify that the information given above is true and complete and I authorize the carrier mentioned above to open my baggage on my behalf for customs examination.',
                // skiBoots: 'Ski boots/boot bag',
                // skis: 'Skis and/or poles',
                // skip: 'Skip',
                // sleepingBag: 'Sleeping bag/bedroll/tent',
                // snowboard: 'Snowboard/Sled',
                // sportEquipment: 'Sports/Outdoor equipment',
                state: 'State',
                // storageContainer: 'Storage container',
                // submit: 'Submit',
                // submitted: 'Updated',
                // surfEquipment: 'Surf equipment',
                // tagNumber: 'Bag Tag Number',
                // temporaryAddressExpired:
                //     'Your current address is no longer valid. Please update the expiry time or provide a permanent address where we can send your belongings.',
                // temporaryAddressValidUntil:
                //     'I will be at this temporary address until',
                // temporaryPhone: 'Temporary phone',
                // titleAddressForm: 'Provide your details',
                // titleBagDetails: 'Bag Details',
                // titleBagInformationForm: 'Describe your belongings',
                // titleClaimSubmitted: 'Your report was submitted',

                // titleClaimSubmittedText1:
                //     'Your delayed bag file has been updated.\n\nPlease',
                // titleClaimSubmittedText2:
                //     'to track your belongings and receive progress notifications.',
                // claimSubmitted: 'download the Air Canada App',
                // claimSubmittedUrl:
                //     'https://www.aircanada.com/ca/en/aco/home/fly/air-canada-on-your-mobile-device.html#/',

                // titleClaimSummary1: 'Delayed Bag File Summary',
                // titleClaimSummary2: 'Home/Permanent Address',
                // titleClaimSummary3: 'Temporary Address',
                // titleClaimSummary4: 'Delivery Address',
                // titleCustomsForm: 'Customs Declaration',
                // titleGeneralError: 'An error has occurred',
                // titleLandingPage: 'Report your delayed bag',
                // titleLandingPage2: 'Search for your delayed bag',
                // titleMissingBagContents:
                //     'Do the missing bags contain any of the following?',
                // titlePassengerDetails: 'Passenger Details',
                // titlePassengerInformation: 'Passenger Information',
                // titleSubmitClaim: 'Report your delayed bag',
                // toolBox: 'Tool/tackle box',
                // tracerReference: 'Delayed Bag File #:',
                // tracerReferenceErrorAirlineCode:
                //     'Please provide 2 character airline code',
                // tracerReferenceErrorRecordDigits:
                //     'Please provide record number digits',
                // tracerReferenceErrorStationCode:
                //     'Please provide 3 letter station code',
                // trackMyBag: 'Search',
                // trunk: 'Trunk/Sample display case',
                // tube: 'Tube not containing sports equipment',
                // type: 'Type',
                // umbrella: 'Umbrella (all types)',
                // umbrellaStroller: 'Umbrella stroller',
                // upright: 'Upright design',
                // uprightCombined: 'Upright design, combined material',
                // uprightExpandable: 'Upright design, expandable',
                // uprightHard: 'Upright design, hard shell',
                // uprightSoft: 'Upright design, soft shell',
                // valueOfGoods: 'Cost or est. Value in CAD ($)',
                // wheelchair: 'Wheelchair and accessories',
                // wheeledSportsItem: 'Wheeled sports item',
                // white: 'White',
                // yellow: 'Yellow',
                // yes: 'Yes',
                // zipper: 'My bag closes with a zipper',
                // zipperBags: 'Bags with a zipper',
                // zipperType: 'Zipper type',
                // events: {
                //     BagAcceptedDeclaration: 'Bag Checked In',
                //     BagCreated: 'Bag Created',
                //     BagDeliveredToCarouselDeclaration:
                //         'Bag Delivered to Baggage Belt',
                //     BagItineraryChanged: 'Bag Itinerary Changed',
                //     BagLoadedOnAircraftDeclaration: 'Bag Loaded On Aircraft',
                //     BagMishandledDeclaration: 'Bag Mishandled',
                //     BagReadyForLoadingDeclaration: 'Bag Ready For Loading',
                //     BagSeenAtStationDeclaration: 'Transfer Bag Received',
                //     BagTransferredToCarrierDeclaration:
                //         'Bag Transferred To Carrier',
                //     TracerRecordCreatedEvent: 'Tracer Record Created',
                //     UnknownEvent: 'Unknown Event',
                // },
            },
        },
        fr: {
            translation: {
                address: 'Adresse',
                addressExpiry: 'L’adresse expire le',
                addressExpiryPastTense: 'L’adresse a expiré le',
                additionalDetails: '[fr] Additional details',
                and: '[fr] and',
                appleAirTag:
                    'Partager l’emplacement d’un AirTag d’Apple (facultatif)',
                appleAirTagErrorMessage:
                    'L’adresse URL fournie pour l’AirTag n’est pas valide. Veuillez vous assurer que l’adresse URL commence par « find.apple.com ».',
                appleAirTagHowTo: 'Comment partager l’emplacement d’un AirTag',
                appleAirTagHowToLink:
                    'https://support.apple.com/fr-ca/guide/iphone/iph3bedf2cc5/ios',
                appleAirTagUrl: 'Adresse URL du AirTag d’Apple',
                appleAirTagPlaceholder:
                    'Entrez l’adresse URL permettant de déterminer l’emplacement de votre AirTag d’Apple',
                artPortfolio: 'Carton à dessins/publicité',
                audioVideoEquipment: 'Équipement audio/vidéo/visuel/photo',
                babyCarriage: "Landau d'enfant",
                back: 'Retour',
                bags: '[fr] bags',
                bagWarningModalHeader:
                    '[fr] Alert: Too many {{itemType}} selected',
                bagWarningModalBody:
                    '[fr] Please reduce the number of {{itemType}} selected to less than {{itemCount}}',
                backpack: 'Sac à dos',
                baggageTrolley: 'Chariot à bagages',
                beddingBag: "Sac d'articles de literie",
                beige: 'Beige',
                bicycle: 'Vélo et accessoires',
                black: 'Noir',
                blue: 'Bleu',
                bookingReference: 'Numéro de réservation',
                box: 'Boîte',
                boxes: 'Boîtes/caisses',
                brand: '[fr] Brand',
                brandPlaceholder: '[fr] Brand Placeholder',
                briefcase: 'Malette',
                brown: 'Brun',
                cancel: 'Annuler',
                carSeat: "Siège d'auto pour enfant/bébé",
                cellNumber: 'Numéro de téléphone secondaire',
                child: 'Article pour bébés/enfants',
                city: 'Ville',
                claimNumber: 'Numéro de dossier du bagage retardé',
                claimNumberPlaceholder: 'Par exemple: YYZAC12345',
                close: 'Fermer',
                clear: 'Effacer',
                colour: 'Couleur',
                computerEquipment: 'Ordinateur/équipement de communication',
                contactInformation: 'Coordonnées',
                contactInformation1:
                    "Pour obtenir des mises à jour sur l'état de votre dossier, visitez le site:",
                contactInformation2: 'Appelez-nous sans frais au ',
                contactLink: 'https://www.aircanada.com/bagagesretardes',
                contactLinkUrl: 'https://www.aircanada.com/bagagesretardes',
                contactPhoneNumber: '1-888-689-BAGS (2247)',
                cooler: 'Glacière/boîte isolante',
                cosmeticCase: 'Coffret à cosmétiques/produits de beauté',
                continue: '[fr] Continue',
                country: 'Pays',
                courierBag: 'Sac messager/boîte/colis',
                customsDateOfBirth: 'Date de naissance - YYYY/MM/DD',
                customsDeclarationSignoff:
                    'SIGNATURE DE LA DÉCLARATION DE DOUANE',
                customsDepartureCountry: "D'où arrivez-vous? (Pays)",
                customsIsCanada: 'Résidez-vous au Canada?',
                customsNonResident: 'Non-résident du Canada',
                customsResident: 'Résident du Canada',
                customsStayOrLeaveDuration:
                    'Combien de jours avez-vous passés à l’extérieur du Canada ou combien de jours allez-vous séjourner au Canada?',
                customsWarning:
                    'ATTENTION : les bagages font l’objet d’un examen par la douane, et des peines sévères peuvent être imposées en cas de fausse déclaration',
                deliveryAddress: 'Adresse de livraison',
                deliveryAddressTitle: 'Adresse de livraison actuelle',
                discardClaim: 'Ignorer et quitter',
                discardClaimConfirmation:
                    'Voulez-vous vraiment quitter? Vos modifications seront perdues.',
                diveBag: 'Sac/équipement de plongée',
                documentCase: 'Porte-documents',
                duffel: 'Fourre-tout/sac de sport',
                dutyFreeItems: 'Articles hors taxes',
                editHomeAddressInstruction:
                    'Votre adresse de livraison actuelle est temporaire. Pour éviter des retards inutiles, veuillez fournir une adresse domiciliaire permanente où nous pourrons envoyer vos bagages au cas où votre adresse temporaire actuelle ne serait plus valide. Nous pourrons ainsi vous rendre vos biens le plus vite possible.',
                electricalAppliance: 'Appareils électroménagers',
                emailAddress: 'Adresse électronique',
                emailMe: '[fr] Email Me',
                familyName: 'Nom de famille',
                fileClaim: 'Organiser la livraison',
                fileNumber: 'Numéro de dossier',
                firearm: 'Arme(s) à feu',
                fishingRod: 'Cannes à pêche',
                foldingChair: 'Chaise pliante',
                frequentFlyerNumber: 'Numéro Aéroplan',
                frequentFlyerPlaceholder: 'Exemple Aéroplan : AC123456789',
                frequentFlyerMissingStartingLetters:
                    'Le numéro Aéroplan n’est pas valide, il doit comprendre les deux lettres du code de transporteur au début.',
                frequentFlyerNotAlphaNumeric:
                    'Le numéro Aéroplan fourni n’est pas valide.',
                frequentFlyerNotLongEnough:
                    'Le code de transporteur doit être suivi d’au moins 9 chiffres.',
                garmentBag: 'Housse à vêtements/sac à vêtements',
                generalConditions:
                    'Conditions générales de transport et tarifs',
                generalConditionsUrl:
                    'https://www.aircanada.com/ca/fr/aco/home/legal/conditions-carriage-tariffs.html#/',
                generalBagPolicy:
                    'Informations sur les bagages retardés ou manquants',
                generalBagPolicyUrl:
                    'https://www.aircanada.com/ca/fr/aco/home/plan/baggage/delayed-damaged-baggage.html#/',
                golfBag: 'Sac et bâtons de golf',
                green: 'Vert',
                grey: 'Gris',
                hatBox: 'Boîte à chapeau',
                horizontalExpandable: 'Valise de modèle horizontal extensible',
                horizontalHardshell:
                    'Valise de modèle horizontal, matériau rigide',
                horizontalNonExpandable:
                    'Valise de modèle horizontal non extensible',
                horizontalSuitcase: 'Valise de modèle horizontal',
                inputInvalid: 'ce champ est invalide',
                instructionInvalidFieldError:
                    'Veuillez remplir les champs essentiels suivants pour rechercher le dossier de bagages retardés :',
                inputTooShort: 'Entrez au moins {{length}} caractères',
                instructionAddressForm:
                    'Indiquez-nous l’adresse de livraison pour le retour de vos bagages ainsi que vos coordonnées afin que nous puissions vous tenir au courant.\n\nVous pourrez apporter des changements en nous appelant après la création de votre dossier.',
                instructionAddressFormTracerAddress:
                    'Tenez-vous au courant en fournissant vos coordonnées et l’adresse de livraison.',
                instructionBagDetails:
                    '[fr] View your item details as it is processed and loaded for the journey',
                instructionBagInformationForm:
                    'Veuillez nous indiquer la couleur et le type de vos bagages retardés, pour aider notre équipe du Rapprochement à les repérer visuellement. En cas de doute sur la couleur et le type de chaque bagage, sélectionnez la meilleure correspondance possible. Vous pourrez modifier votre dossier une fois celui-ci créé.',
                instructionClaimSubmitted:
                    'Merci d’avoir soumis des renseignements concernant vos bagages retardés',
                instructionClaimSummary1:
                    '\nModifier les renseignements pertinents pour mettre à jour le dossier',
                instructionGeneralError:
                    "À l'heure actuelle, nous ne sommes pas en mesure de déterminer l'état de vos bagages",
                instructionLandingPageDelayedBagFileSearch:
                    'Pour modifier les renseignements personnels associés au dossier de votre bagage retardé (p. ex. l’adresse de livraison), veuillez indiquer les renseignements demandés.',
                instructionLandingPage:
                    'Entrez vos renseignements ci-dessous pour faire ouvrir un dossier de bagages retardés et organiser la livraison de vos biens s’ils ne sont pas arrivés par votre vol Air Canada.\n\nLa recherche n’affichera que les passagers figurant sur la réservation qui portent le même nom de famille. Si d’autres passagers sur la réservation portent un nom de famille différent, présentez un nouveau rapport pour chacun d’entre eux lorsque vous aurez fini de remplir le présent dossier.',
                instructionNoPassengers:
                    'Aucun bagage mal acheminé pour le moment',
                instructionPassengerDetails:
                    '[fr] Select your item to view its journey',
                instructionSearchClaim1:
                    '[fr] Already have a delayed bag file number?',
                instructionSearchClaim2: '',
                searchMyClaim: 'Rechercher',
                searchAgain: 'Faire une nouvelle recherche',
                instructionPrivacyStatement:
                    "Avis relatif à la protection des renseignements personnels\nL'information fournie dans le présent formulaire, qui a été recueillie en vertu de l'article 12 de la Loi sur les douanes, est requise en vue de déterminer l'admissibilité des marchandises que vous importez ainsi que les droits et taxes à payer. Les renseignements peuvent être divulgués à des agents des transporteurs aériens et au personnel des entreprises de manutention des bagages pour que vos marchandises soient présentées à l'Agence des services frontaliers du Canada (ASFC) aux fins d'examen.\n\nLe fait de ne pas remplir ce formulaire pourrait entraîner la prise de mesures punitives, y compris la saisie de vos marchandises. Vous avez le droit d'accéder à vos renseignements personnels et d'y apporter des corrections en vertu de l'article 12 de la Loi sur la protection des renseignements personnels. Les renseignements recueillis sont décrits dans le fichier de renseignements personnels Rapport de bagages retardés ASFC PPU 1109, qui est présenté en détail sur le site ",

                instructionSubmitClaim:
                    'Cochez les bagages que vous voulez signaler comme retardés. Un dossier de bagages retardés sera créé, ce qui nous permettra de faire le suivi. Aux étapes suivantes, vous devrez fournir des renseignements permettant de repérer vos bagages ainsi que vos coordonnées et l’adresse de livraison pour que nous puissions vous rendre vos biens le plus vite possible.\n\nLa liste ci-dessous n’affiche que le nom des passagers figurant sur la réservation et portant le même nom de famille. Si d’autres passagers portant un nom de famille différent sont concernés, suivez la même procédure en indiquant leur nom.',
                isTemporary:
                    'Je séjournerai à cette adresse pour une durée limitée',
                item: 'Article',
                laptop: "Mallette d'ordinateur portable/sac de voyage",
                luggage: 'Bagages',
                luggageMiscellaneous: 'Sélectionnez le type',
                mattedWovenBag: 'Sac en tissu feutré',
                militaryStyleBag: 'Sac de style militaire',
                miscellaneous: 'Autre article divers',
                mobility:
                    'Appareil médical/fauteuil roulant/aide à la mobilité',
                multicolour: 'Multicolore',
                musicalInstrument: 'Instrument de musique',
                next: 'Continuer',
                no: 'Non',
                noBagEventsMessage: '[fr] No declarations found for this bag',
                noBagInformation1:
                    'Nous sommes désolés. Un problème nous empêche de récupérer les renseignements sur vos bagages retardés.',
                noBagInformation2:
                    "Veuillez vous adresser à un agent d'Air Canada pour obtenir de l'aide avant de quitter l'aéroport.",
                noPassengersMessage:
                    'Impossible de trouver le dossier lié aux bagages retardés avec les renseignements fournis.',
                nonResidentInstruction1:
                    'Les bagages manquants renferment-ils les marchandises suivantes?',
                noResults: 'Aucun résultat',
                noZipper: 'Mon bagage se referme sans fermeture éclair',
                noZipperBags: 'Bagages sans fermeture éclair',
                notes: '[fr] Notes',
                notesPlaceholder: '[fr] Notes Placeholder',
                notificationModalHeader: '[fr] Turn On Notifications',
                notificationModalInstruction1:
                    '[fr] Enter your email to receive notifications alerts about your bag status',
                notificationModalInstruction2: '[fr] Receive alerts',
                notificationModalTitle: '[fr] Get Notified',
                notifyMe: '[fr] Notify Me',
                optional: 'facultatif',
                or: 'Ou',
                orthopaedicDevice: 'Appareils orthopédiques',
                other: 'Autre',
                otherChildEquipment:
                    'Équipement pour enfant/bébé autre que ceux indiqués',
                otherSportEquipment:
                    'Équipement de sport - autre que ceux illustrés',
                passengers: '[fr] passengers',
                passengersExpiredMessage:
                    "Nous sommes désolés. Un problème nous empêche de récupérer les renseignements sur vos bagages retardés.\n\nVeuillez vous adresser à un agent d'Air Canada pour obtenir de l'aide avant de quitter l'aéroport.",
                pattern: 'Motif',
                petCarrier: 'Niche/cage pour animal domestique',
                permanentPhone: 'Numéro de téléphone permanent',
                phoneNumber: 'Numéro de téléphone',
                phoneNumberPlaceholder: '',
                plasticLaundryBag: 'Sac en plastique/sac à lessive',
                postalCode: 'Code postal/ZIP',

                poweredBy: 'Propulsé par',
                prohibitedItems1: 'Alcool',
                prohibitedItems2: 'Tabac',
                prohibitedItems3:
                    "Armes à feu ou autres armes (p. ex. couteaux à cran d'arrêt, Mace ou gaz poivré)",
                prohibitedItems4:
                    'Marchandises commerciales destinées ou non à la revente (p. ex. échantillons, outils, équipement)',
                prohibitedItems5:
                    'Viande, poisson, fruits de mer, œufs, produits laitiers, fruits, légumes, semences, noix, plantes, fleurs, bois, animaux, oiseaux, insectes, et des parties, produits ou sous-produits quelconque de ce qui précède',
                prohibitedItems6:
                    'Espèces et/ou effets dont le montant total équivaut à 10 000 $CAN ou plus par personne',
                prohibitedItems7: 'Aucune de ces réponses',
                purple: 'Violet',
                red: 'Rouge',
                save: 'Enregistrer',
                residentInstruction1:
                    "Quelle est la valeur totale des articles rapportés au Canada que vous avez déclarés comme ayant été achetés, reçus ou acquis, d'une façon ou d'une autre, à l'étranger, incluant les marchandises achetées dans les boutiques hors taxes au Canada ou à l'étranger?",
                residentInstruction2:
                    'Au meilleur de votre connaissance, quelle est la valeur totale des marchandises susmentionnées qui sont contenues dans vos bagages manquants?',
                securityRemovedItem: 'Articles retirés à la sécurité',
                selectColour: 'Sélectionnez la couleur',
                selectPassengers: '[fr] Select Passenger(s)',
                selectType: 'Sélectionnez le type',
                shoppingBag: 'Sac à provisions (tous les matériaux)',
                signatureCertification:
                    "Je déclare que les renseignement ci-dessus sont exacts et complets, et j'autorise le transporteur indiqué cidessus à ouvrir mes bagages en mon nom pour l'examen des douanes.",
                signatureOfTraveller: 'Signature du voyageur',
                skiBoots: 'Bottes de ski/sac à bottes',
                skis: 'Skis/bâtons de ski',
                skip: 'Passer',
                sleepingBag: 'Sac de couchage/lit-sac/tente',
                snowboard: 'Planche à neige et autre équipement de glisse',
                sportEquipment: 'Équipement de sport ou de plein air',
                state: 'Province/État',
                storageContainer: 'Bac de rangement',
                submit: 'Soumettre',
                submitted: 'Mis à jour',
                surfEquipment: 'Équipement de surf',
                tagNumber: 'Numéro de l’étiquette de bagages',
                temporaryAddressExpired:
                    'Votre adresse actuelle n’est plus valide. Veuillez mettre à jour l’heure d’expiration ou fournir une adresse permanente pour nous permettre de vous rendre vos biens.',
                temporaryAddressValidUntil:
                    "Je séjournerai à cette adresse temporaire jusqu'au",
                temporaryPhone: '[fr] Temporary phone #',
                titleAddressForm: 'Inscrire ses coordonnées',
                titleBagDetails: 'Renseignements sur les bagages',
                titleBagInformationForm: 'Donner la description de ses biens',
                titleClaimSubmitted: 'Votre rapport a été envoyé',
                titleCustomsForm: 'Déclaration de douane',

                titleClaimSubmittedText1:
                    'Le dossier lié à vos bagages retardés a été mis à jour.\n\nVeuillez',
                titleClaimSubmittedText2:
                    'pour suivre vos effets personnels et recevoir des avis sur l’état de votre dossier.',
                claimSubmitted: 'télécharger l’application mobile Air Canada',
                claimSubmittedUrl:
                    'https://www.aircanada.com/ca/fr/aco/home/fly/air-canada-on-your-mobile-device.html#/',

                titleClaimSummary1: 'Sommaire du dossier pour bagages retardés',
                titleClaimSummary2: 'Adresse domiciliaire/permanente',
                titleClaimSummary3: '[fr] Temporary Address',
                titleClaimSummary4: 'Adresse de livraison',
                titleGeneralError: 'Une erreur s’est produite',
                titleLandingPage: 'Signaler des bagages retardés',
                titleLandingPage2: 'Chercher votre bagage retardé',
                titleMissingBagContents:
                    'Les bagages manquants renferment-ils les marchandises suivantes?',
                titlePassengerDetails: '[fr] Passenger Details',
                titlePassengerInformation: 'Renseignements sur le passager',
                titleSubmitClaim: 'Signaler des bagages retardés',
                toolBox: 'Coffre à outils/à pêche',
                tracerReference: 'Dossier pour bagages retardés #:',
                tracerReferenceErrorAirlineCode:
                    'Veuillez fournir les deux caractères du code de transporteur',
                tracerReferenceErrorRecordDigits:
                    'Veuillez fournir les chiffres du numéro de dossier',
                tracerReferenceErrorStationCode:
                    'Veuillez fournir les trois lettres du code d’escale',
                trackMyBag: 'Rechercher',
                trunk: 'Malle/échantillon/étui de présentation',
                tube: 'Tube (sans équipement de sport)',
                type: 'Type',
                umbrella: 'Parapluie (tout genre)',
                umbrellaStroller: 'Poussette-canne',
                upright: 'Modèle vertical',
                uprightCombined:
                    'Modèle vertical combinant des matériaux souples et rigides',
                uprightExpandable: 'Modèle vertical extensible',
                uprightHard: 'Modèle vertical, matériau rigide',
                uprightSoft: 'Modèle vertical, matériau souple',
                valueOfGoods: 'Coût ou valeur estimée en $ CA',
                wheelchair:
                    'Fauteuil roulant, électrique ou manuel, et accessoires',
                wheeledSportsItem: 'Articles de sport sur roues',
                white: 'Blanc',
                yellow: 'Jaune',
                yes: 'Oui',
                zipper: 'Mon bagage se referme avec une fermeture éclair',
                zipperBags: 'Bagages avec fermeture éclair',
                zipperType: 'Type de fermeture éclair',
                events: {
                    BagAcceptedDeclaration: '[fr] Bag Checked In',
                    BagCreated: '[fr] Bag Created',
                    BagDeliveredToCarouselDeclaration:
                        '[fr] Bag Delivered to Baggage Belt',
                    BagItineraryChanged: '[fr] Bag Itinerary Changed',
                    BagLoadedOnAircraftDeclaration:
                        '[fr] Bag Loaded On Aircraft',
                    BagMishandledDeclaration: '[fr] Bag Mishandled',
                    BagReadyForLoadingDeclaration: '[fr] Bag Ready For Loading',
                    BagSeenAtStationDeclaration: '[fr] Transfer Bag Received',
                    BagTransferredToCarrierDeclaration:
                        '[fr] Bag Transferred To Carrier',
                    TracerRecordCreatedEvent: '[fr] Tracer Record Created',
                    UnknownEvent: '[fr] Unknown Event',
                },
            },
        },
    },
});

export default disneyInstance;
